"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.preview.title': 'Podgląd awatara',
    'avatar.preview.edit': 'Edytuj awatar',
    'avatar.preview.back': 'Powrót do listy',
    'avatar.preview.not_provided': 'Nie podano',
    'avatar.preview.section.basic_info': 'Informacje podstawowe',
    'avatar.preview.section.logo': 'Logo awatara',
    'avatar.preview.section.description': 'Opis',
    'avatar.preview.section.ai_model': 'Konfiguracja modelu AI',
    'avatar.preview.section.knowledge': 'Baza wiedzy',
    'avatar.preview.section.settings': 'Ustawienia awatara',
    'avatar.preview.section.validation': 'Status konfiguracji',
    'avatar.preview.logo.not_uploaded': 'Nie przesłano logo',
    'avatar.preview.provider': 'Dostawca',
    'avatar.preview.cost': 'Koszt',
    'avatar.preview.model.not_selected': 'Nie wybrano modelu AI - To jest wymagane!',
    'avatar.preview.knowledge.entries_selected': 'wpisów wiedzy wybrano',
    'avatar.preview.knowledge.none_selected': 'Nie wybrano wpisów bazy wiedzy',
    'avatar.preview.validation.status': 'Walidacja konfiguracji',
    'avatar.preview.validation.complete': 'Wszystkie wymagane pola są wypełnione',
    'avatar.preview.validation.incomplete': 'Brakuje niektórych wymaganych pól',
    'avatar.preview.no_data': 'Brak dostępnych danych awatara',
    'avatar.preview.error.load_failed': 'Błąd ładowania awatara do podglądu',
    'avatar.preview.voice.not_selected': 'Nie wybrano głosu',
    'avatar.preview.unnamed': 'Avatar Bez Nazwy',
    'avatar.preview.required': 'Wymagane',
    'avatar.preview.gender.not_selected': 'Nie wybrano płci',
    'avatar.preview.section.conversations': 'Konwersacje',
    'avatar.preview.conversations.empty': 'Brak konwersacji z tym awatarem',
    'avatar.preview.conversations.untitled': 'Konwersacja bez tytułu',
};
